import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AdminMergeResultDto {
  @Field()
  success!: boolean
}
